import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { XmlparseService } from '../xml/xmlparse.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';

import { AlertService } from "../../services/alert/alert.service";
import { IceTypes } from "../../models/icetypes";
import { Iceutility } from "../../services/iceutility";
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';
import { provider } from '../../models/domain/provider';
import { appointment } from '../../models/schedule/appointment';
import { provider_index } from '../../models/domain/provider_index';

declare var require: any;

@Injectable({
  providedIn: 'root'
})
export class ProviderService extends DomainService {

  constructor(http: HttpClient,
    alertSvc: AlertService,
    loginSvc: LoginService) {

    super(http, alertSvc, loginSvc);
  }

  insertProvider(domaintype: IceTypes.ACCOUNT_TYPE, pro: provider, members: string): Observable<any> {
    if (Iceutility.isdefined(pro) == false) throw "Provider service Insert provider has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=&data=addprovider&key=&subkeys=domaintype:" + domaintype.toString() + ";lastname:;members:" + (members == null ? "" : members);
    let tblname = pro.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(pro) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PROVIDER", "FACILITY"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  updateProvider(pro: provider, domaintype: IceTypes.ACCOUNT_TYPE, hieUpdateDisable: boolean = false, pros: provider_index[] = null): Observable<any> {
    if (Iceutility.isdefined(pro) == false) throw "Provider service Insert provider has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + pro.trans_account + "&data=updateprovider&key=&subkeys=domaintype:" + domaintype.toString() + ";lastname:" + ";hieupdate:" + (hieUpdateDisable ? "true" : "false");
    let tblname = pro.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(pro) + "}";
    if (pros != null && pros.length > 0) {
      try {
        let tempobj = JSON.parse(data);
        tempobj["PROS"] = pros
        let tempjson = JSON.stringify(tempobj);
        data = tempjson;
      }
      catch (e) {
        console.log(e);
      }
    }
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PROVIDER", "FACILITY"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  public getProviders(): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=&data=&key=&subkeys=domaintype:;lastname:;members:;";
    return this.getHttp().get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PROVIDER_INDEX"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  getPracticeProviders(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, uid: string) {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";
    if (domain == null || domain.length == 0) throw "Domain is required.";

    let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + domain + "&key=" + "&subkeys=uid:" + uid + "&data=practiceproviders" + "&acttype=" + domaintype;
    return this.getHttp().get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PROVIDER_INDEX"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  public getAppointment(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, apptkey: string) {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";
    if (domain == null || domain.length == 0) throw "Domain is required.";
    if (apptkey == null || apptkey.length == 0) throw "Appointment key is required.";

    let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + domain + "&key=" + apptkey + "&data=appointment" + "&acttype=" + domaintype + "&patientdomain=&subkeys=";
    return this.getHttp().get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["APPOINTMENT"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  insertUpdateAppointment(appointmentdata: appointment, domain: string, ptdomain: string, domaintype: IceTypes.ACCOUNT_TYPE): Observable<any> {
    if (Iceutility.isdefined(appointmentdata) == false) throw "Provider service Insert/Update appointment has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Provider service is not configured.";

    let url = ""; 
    if (appointmentdata.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {
      url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + domain + "&patientdomain=" + ptdomain + "&data=appointment&subkeys=&key=&acttype=" + domaintype;
    } else {
      url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=" + domain + "&patientdomain=" + ptdomain + "&data=updateappointment&subkeys=&key=" + appointmentdata.appointment_key + "&acttype=" + domaintype;
    }

    let tblname = appointmentdata.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(appointmentdata) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["APPOINTMENT"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }
}
